// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1jtTv","errors":"Errors_errors__1H-Bs"};